(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categories-slider"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.collectionSwiper', {
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      325: { slidesPerView: 1.5 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
